<template>
  <div class="form-group row">
    <label class="col-sm-3 control-label">Network Types</label>
    <div class="col-sm-9">
      <div ref="pickerRef" class="vm-search-select">
        <input type="hidden" name="network[segment_type_id]" class="vm-search-select-value" :value="selectedValue">
        <button
          type="button"
          class="form-control vm-search-select-trigger"
          :aria-expanded="open ? 'true' : 'false'"
          @click.stop="togglePicker"
        >
          <span class="vm-search-select-trigger-label">{{ selectedLabel }}</span>
          <span class="caret"></span>
        </button>
        <div v-if="open" class="vm-search-select-panel" @click.stop>
          <input
            v-model="filterKeyword"
            type="text"
            class="form-control vm-search-select-input"
            placeholder="Filter network types"
          >
          <div class="vm-search-select-options">
            <button
              v-for="option in filteredOptions"
              :key="`segment-type-${option.value}`"
              type="button"
              class="vm-search-select-option"
              :class="{ 'is-selected': selectedValue === option.value }"
              @click="selectOption(option.value)"
            >
              {{ option.label }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from "vue"

const props = defineProps({
  options: {
    type: Array,
    default: () => []
  },
  initialValue: {
    type: [String, Number],
    default: ""
  }
})

const pickerRef = ref(null)
const open = ref(false)
const filterKeyword = ref("")
const selectedValue = ref(String(props.initialValue || ""))

const normalizedOptions = computed(() =>
  (props.options || []).map((option) => ({
    label: option.label,
    value: String(option.value)
  }))
)

const filteredOptions = computed(() => {
  const keyword = filterKeyword.value.trim().toLowerCase()
  if (!keyword) return normalizedOptions.value
  return normalizedOptions.value.filter((option) => option.label.toLowerCase().includes(keyword))
})

const selectedLabel = computed(() => {
  return normalizedOptions.value.find((option) => option.value === selectedValue.value)?.label || "Select a network type"
})

function togglePicker() {
  open.value = !open.value
  if (!open.value) {
    filterKeyword.value = ""
  }
}

function selectOption(value) {
  selectedValue.value = String(value)
  open.value = false
  filterKeyword.value = ""
}

function closeOnOutsideClick(event) {
  if (pickerRef.value && !pickerRef.value.contains(event.target)) {
    open.value = false
    filterKeyword.value = ""
  }
}

onMounted(() => {
  document.addEventListener("click", closeOnOutsideClick)
})

onBeforeUnmount(() => {
  document.removeEventListener("click", closeOnOutsideClick)
})
</script>
